import React from 'react';
import { message } from 'antd';
import s from './s.module.less';

/**
 * 保存成功提示。设计系统 §2.11 的那颗「绿色实心圆 + 白勾」，
 * antd 默认是绿色线性描边的 check-circle，不是一个东西。
 *
 * 只接管这颗胶囊的外观，不动 message 的全局位置：
 * 位置在 .ant-message 容器上，而 className 只落到 .ant-message-notice，
 * 够不着父级；要改就得 message.config({ top })，那是全站副作用。
 * 差 16px 的垂直偏移，不值得动全站。
 */
const ToastIcon = () => (
    <span className={s.toastIcon}>
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M20 6L9 17l-5-5" />
        </svg>
    </span>
);

export const successToast = (content: string): void => {
    message.success({ content, className: s.toast, icon: <ToastIcon /> });
};
